<template>
    <div>
        <CRow>
            <CCol>
                <div style="width:100%; height: 75vh;">
                    <ejs-grid ref='gridro' :dataSource='ricData' :allowFiltering='true' :allowPaging='true' :allowResizing='true'
                              :allowReordering='true' :allowSorting='true' :toolbar='toolbar' :editSettings='editSettings' :enablePersistence ="true"
                              :pageSettings='pageSettings' :filterSettings='filterOptions' :toolbarClick='toolbarClick' :actionBegin='actionBegin' :actionFailure="actionFailure" :actionComplete="actionComplete"
                              :allowExcelExport='true' :excelExportComplete='excelExportComplete' width="100%" height="100%">
                        <e-columns>
                            <e-column field='id' headerText='Id' :isPrimaryKey='true' :visible='false'></e-column>
                            <e-column field='core' headerText='Identifier' :validationRules="requiredRules" width=120></e-column>
                            <e-column field='utilityType' headerText='Commodity' :validationRules="requiredRules" width=120 :edit='utilitiesOtherParams' foreignKeyField='id' foreignKeyValue='name' :dataSource='utilitiesOther' editType='dropdownedit'></e-column>
                            <e-column field='periodType' headerText='Period Type' :validationRules="requiredRules" width=120 :edit='periodTypeParams' foreignKeyField='id' foreignKeyValue='name' :dataSource='otherPeriodTypes' editType='dropdownedit'></e-column>
                            <e-column field='periodCodeType' headerText='Period Code Type' textAlign='Right' :validationRules='numericRules' editType='numericedit' :edit='numericParams' width=90></e-column>
                            <e-column field='description' headerText='Description' :validationRules="requiredRules" width=120></e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
            </CCol>
        </CRow>
    </div>
</template>
<script>

    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import { DropDownList, DropDownListPlugin } from "@syncfusion/ej2-dropdowns";
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import gridOptions from '../../../common/gridOptions'
    import SyncHelper from '../../../common/syncfusion'
    import store from '../../../store';
    Vue.use(DialogUtility);
    Vue.use(GridPlugin);

    let  dpUtilitiesOther, elUtilitiesOther, periodTypeElem, periodTypeObj;

    export default {
        name: 'RIC',
        data() {
            return {
                store: store,
                ricData: SyncHelper.getDataManager("RICOtherInstruments"),
                pageSettings: gridOptions.pageSettings,
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowEditing: store.state.permissions["Permissions.RicOtherInstruments.Update"],
                    allowAdding: store.state.permissions["Permissions.RicOtherInstruments.Create"],
                    allowDeleting: store.state.permissions["Permissions.RicOtherInstruments.Delete"],
                    mode: 'Dialog'
                },
                numericParams: {
                    params: {
                        validateDecimalOnType: true,
                        decimals: 0,
                        format: "N"
                    }
                },
                requiredRules: { required: true },
                numericRules: { number: true },
                toolbar: ['Add', 'Edit', 'Delete', 'ExcelExport'],
                utilitiesOther: SyncHelper.getDataManager("utils/otherUtilityTypes"),
                otherPeriodTypes: SyncHelper.getDataManager('Utils/otherPeriodTypes'),
                periodTypeParams: {
                    create: () => {
                        periodTypeElem = document.createElement('input');
                        return periodTypeElem;
                    },
                    read: () => {
                        return periodTypeObj.value;
                    },
                    destroy: () => {
                        periodTypeObj.destroy();
                    },
                    write: (args) => {
                        periodTypeObj = new DropDownList({
                            dataSource: this.otherPeriodTypes,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Period Type',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            cssClass: 'required-input',
                        });
                        periodTypeObj.appendTo(periodTypeElem);
                    }
                },
                utilitiesOtherParams: {
                    create: () => {
                        elUtilitiesOther = document.createElement('input');
                        return elUtilitiesOther;
                    },
                    read: () => {
                        return dpUtilitiesOther.value;
                    },
                    destroy: () => {
                        dpUtilitiesOther.destroy();
                    },
                    write: (args) => {
                        dpUtilitiesOther = new DropDownList({
                            dataSource: this.utilitiesOther,
                            fields: {
                                text: args.column.foreignKeyValue,
                                value: args.column.foreignKeyField
                            },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Commodity',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            cssClass: 'required-input',
                        });
                        dpUtilitiesOther.appendTo(elUtilitiesOther);
                    }
                },
                filterOptions: gridOptions.filterSettings,
            }
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
        },
        methods: {
            toolbarClick(args) {
                gridOptions.excelExport(args, "OtherRICs.xlsx", this.$refs);
            },
            excelExportComplete(args) {
                this.$refs.gridro.hideSpinner();
            },
            actionBegin(args) {
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    for (var i = 0; i < this.$refs.gridro.getColumns().length; i++) {

                    }
                }
                if (args.requestType == 'save') {

                    showSpinner(document.getElementById('mainSpinner'));


                }

                if (args.requestType == 'refresh') {

                    hideSpinner(document.getElementById('mainSpinner'));

                }
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    const arrayFields = ["core","description"]
                    arrayFields.forEach(function (item) {
                        let inputElement = args.form.elements.namedItem(item);
                        if (inputElement) {
                            let parentDiv = inputElement.closest('.e-input-group');
                            if (parentDiv) {
                                parentDiv.classList.add('required-input');
                            }
                        }
                    });
                }
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
                hideSpinner(document.getElementById('mainSpinner'));
            },
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    }
</script>